export default __webpack_public_path__ + "static/media/dietarydiversity2.537ff14e.jpg";